import axios from 'axios';

const api = axios.create({
  baseURL: process.env.REACT_APP_API_URL || 'http://localhost:5000',
  timeout: 30000, // Increased from 10000 to 30000 to handle server cold starts on shared hosting/Passenger
});

// Request interceptor to add auth token
api.interceptors.request.use(
  (config) => {
    const token = localStorage.getItem('flexigym_token');
    if (token) {
      config.headers.Authorization = `Bearer ${token}`;
    }
    return config;
  },
  (error) => {
    return Promise.reject(error);
  }
);

// Response interceptor to handle retries and token expiry
api.interceptors.response.use(
  (response) => {
    return response;
  },
  async (error) => {
    const { config } = error;
    
    // Check if it's a 401 Unauthorized or 422 Unprocessable Entity (expired or invalid token signature)
    if (error.response?.status === 401 || error.response?.status === 422) {
      // Clear auth data and redirect to login
      localStorage.removeItem('flexigym_token');
      localStorage.removeItem('flexigym_user');
      if (window.location.pathname !== '/login') {
        window.location.href = '/login';
      }
      return Promise.reject(error);
    }
    
    // Determine if we should retry (on network connection drops or 5xx server errors, up to 2 retries)
    const isNetworkOrServerError = !error.response || (error.response.status >= 500 && error.response.status <= 599);
    
    if (config && isNetworkOrServerError) {
      // Set the number of retries (up to 2 retries)
      config.__retryCount = config.__retryCount || 0;
      
      if (config.__retryCount < 2) {
        config.__retryCount += 1;
        
        // Linear backoff delay
        const backoffDelay = 800 * config.__retryCount;
        await new Promise((resolve) => setTimeout(resolve, backoffDelay));
        
        console.warn(`API Request failed (${error.message}). Retrying attempt ${config.__retryCount}...`);
        return api(config);
      }
    }
    
    return Promise.reject(error);
  }
);

export default api;